// Platform-neutral token storage. Web uses localStorage; RN will register
// a secure-store adapter. Holds both access and refresh tokens.
export interface TokenStore {
  getAccessToken(scope?: string): string | null;
  setAccessToken(token: string | null | undefined, scope?: string): void;
  getRefreshToken(): string | null;
  setRefreshToken(token: string | null | undefined): void;
  clear(scope?: string): void;
}

let current: TokenStore = {
  getAccessToken: () => null,
  setAccessToken: () => {},
  getRefreshToken: () => null,
  setRefreshToken: () => {},
  clear: () => {},
};

export function registerTokenStore(store: TokenStore) {
  current = store;
}

export function getTokenStore(): TokenStore {
  return current;
}
